import { render, staticRenderFns } from "./orderMGT.vue?vue&type=template&id=10d03696&scoped=true&"
import script from "./orderMGT.vue?vue&type=script&lang=js&"
export * from "./orderMGT.vue?vue&type=script&lang=js&"
import style0 from "./orderMGT.vue?vue&type=style&index=0&id=10d03696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d03696",
  null
  
)

export default component.exports